import Tooltip from '@mui/material/Tooltip';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import BarChartIcon from '@mui/icons-material/BarChart';
import SquareIcon from '@mui/icons-material/Square';
import CircularProgress from '@mui/material/CircularProgress';

import TopCompanyLabel from '../../components/TopCompanyLabel';
import Button from '../../components/Button';
import ECharts from '../../components/ECharts';
import Loading from '../../components/Loading';
import {
  CATEGORIES_COLOR,
  HOME_CHART_COLOR,
  TC_COLORS,
} from '../../constants/colors';
import { parseDate } from '../../utils/date';
import { formatDisplayNumber, formatTradingValue } from '../../utils/format';
import {
  generateMinMaxChartData,
  getAxisLabel,
  getMinMax,
  getStatusColor,
  removeVietnameseTones,
} from '../../utils/helpers';
import { Charts } from '../ManageInvestments/components/TradingVolumeAndClosePriceChartModal';
import WrapperBookmark from './components/WrapperBookmark';
import * as Styles from './Dashboard.styles';

import {
  TOP_10_INCREASE_CHANGE,
  TOP_10_INCREASE_CLOSE_PRICE,
  TOP_10_INCREASE_CODE,
  TOP_10_INCREASE_ICON,
  TOP_10_INCREASE_TRADING_VALUE,
  TOP_10_INCREASE_TRADING_VOLUME,
  TOP_10_LOWEST_CHANGE,
  TOP_10_LOWEST_CLOSE_PRICE,
  TOP_10_LOWEST_CODE,
  TOP_10_LOWEST_ICON,
  TOP_10_LOWEST_TRADING_VALUE,
  TOP_10_LOWEST_TRADING_VOLUME,
  TOP_10_TRADING_VALUE,
  TOP_10_TRADING_VALUE_CHANGE,
  TOP_10_TRADING_VALUE_CODE,
  TOP_10_TRADING_VALUE_ICON,
  TOP_10_TRADING_VOLUME,
  TOP_10_TRADING_VOLUME_CHANGE,
  TOP_10_TRADING_VOLUME_CODE,
  TOP_10_TRADING_VOLUME_ICON,
  TOP_5_NEGOTIABLE_TRADING_VALUE,
  TOP_5_NEGOTIABLE_TRADING_VALUE_CHANGE,
  TOP_5_NEGOTIABLE_TRADING_VALUE_ICON,
  TOP_5_NEGOTIABLE_TRADING_VALUE_PUT_THROUGH,
  TOP_5_NEGOTIABLE_TRADING_VOLUME,
  TOP_5_NEGOTIABLE_TRADING_VOLUME_CHANGE,
  TOP_5_NEGOTIABLE_TRADING_VOLUME_ICON,
  TOP_5_NEGOTIABLE_TRADING_VOLUME_PUT_THROUGH,
  TOP_8_VALUE_SECTOR,
  TOP_8_VALUE_SECTOR_ICON,
  TOP_8_VALUE_SECTOR_TRADING_VOLUME,
  TOP_8_VOLUME_SECTOR,
  TOP_8_VOLUME_SECTOR_ICON,
  TOP_8_VOLUME_SECTOR_TRADING_VOLUME,
  TOP_10_GO_UP_GO_DOWN_CODE,
  TOP_10_GO_UP_GO_DOWN_TRADING_VOLUME,
  TOP_10_GO_UP_GO_DOWN_CHANGE,
  TOP_10_GO_UP_GO_DOWN_ICON,
  TOP_10_GO_UP_GO_DOWN_TRADING_VALUE,
} from './Dashboard.columns';

export const transferTop10IncreaseData = (
  data,
  isInvestmentCategoriesLoading,
  authenticated,
  investmentCategories,
  followCompanies,
  saveInvestmentCategory,
  deleteInvestmentCategory,
  investmentCategoriesMessage,
  isOpeningBookmark,
  handleSetIsOpeningBookmark,
  isDarkMode,
  position,
  onClick,
  handleTooltipOpen,
  top10ChartData
) => {
  return data.map((item) => {
    return {
      [TOP_10_INCREASE_ICON]: (
        <span className="column-icon flex justify-end">
          <Styles.Tooltip
            title={getTop10TooltipContent(
              top10ChartData,
              'klgd',
              item.machungkhoan,
              'KLGD',
              ' cp',
              isDarkMode,
              '',
              '150px',
              60,
              1000
            )}
            placement={position}
            onOpen={() => handleTooltipOpen(item.machungkhoan, 'gtgd')}
          >
            <Styles.Icon>
              <span
                className="whitespace-nowrap cursor-pointer"
                role="button"
                onClick={() =>
                  onClick(item.machungkhoan, {
                    code: item.machungkhoan,
                    name: item.name,
                    label: item.label,
                  })
                }
              >
                <BarChartIcon className="hover:text-primary-main" />
              </span>
            </Styles.Icon>
          </Styles.Tooltip>

          <WrapperBookmark
            code={item.machungkhoan}
            isInvestmentCategoriesLoading={isInvestmentCategoriesLoading}
            authenticated={authenticated}
            investmentCategories={investmentCategories}
            followCompanies={followCompanies}
            saveInvestmentCategory={saveInvestmentCategory}
            deleteInvestmentCategory={deleteInvestmentCategory}
            investmentCategoriesMessage={investmentCategoriesMessage}
            isOpeningBookmark={isOpeningBookmark}
            handleSetIsOpeningBookmark={handleSetIsOpeningBookmark}
          />
        </span>
      ),
      [TOP_10_INCREASE_CODE]: (
        <div className="whitespace-nowrap flex items-center">
          <a
            href={`/${item.machungkhoan.toLowerCase()}-${removeVietnameseTones(
              item.name
            )}`}
            className="text-primary-main"
            title={`${item.name} | Mã chứng khoán: ${item.machungkhoan}`}
          >
            {item.machungkhoan}
          </a>
          <TopCompanyLabel label={item.label} />
        </div>
      ),
      [TOP_10_INCREASE_CLOSE_PRICE]: (
        <span className="whitespace-nowrap">
          {formatDisplayNumber(item.giadongcua, ',', 0)}
        </span>
      ),
      [TOP_10_INCREASE_CHANGE]: (
        <span
          className="whitespace-nowrap"
          style={{
            color: `${getStatusColor(
              item.giadongcua,
              item.giathamchieu,
              item.giatran,
              item.giasan
            )}`,
          }}
        >
          {formatDisplayNumber(item.thaydoi, ',', 0)} (
          {formatDisplayNumber(item.thaydoiphantram, ',', 0)}%)
        </span>
      ),
      [TOP_10_INCREASE_TRADING_VALUE]: (
        <span className="whitespace-nowrap">
          {formatDisplayNumber(
            formatTradingValue(Number(item.gtgd) / 1000),
            ',',
            0
          )}
        </span>
      ),
      [TOP_10_INCREASE_TRADING_VOLUME]: (
        <span className="whitespace-nowrap">
          {formatDisplayNumber(Number(item.klgd), ',', 0)}
        </span>
      ),
    };
  });
};

export const transferTop10LowestData = (
  data,
  isInvestmentCategoriesLoading,
  authenticated,
  investmentCategories,
  followCompanies,
  saveInvestmentCategory,
  deleteInvestmentCategory,
  investmentCategoriesMessage,
  isOpeningBookmark,
  handleSetIsOpeningBookmark,
  isDarkMode,
  position,
  onClick,
  handleTooltipOpen,
  top10ChartData
) => {
  return data.map((item) => {
    return {
      [TOP_10_LOWEST_ICON]: (
        <span className="column-icon flex justify-end">
          <Styles.Tooltip
            title={getTop10TooltipContent(
              top10ChartData,
              'klgd',
              item.machungkhoan,
              'KLGD',
              ' cp',
              isDarkMode,
              '',
              '150px',
              60,
              1000
            )}
            placement={position}
            onOpen={() => handleTooltipOpen(item.machungkhoan, 'gtgd')}
          >
            <Styles.Icon>
              <span
                className="whitespace-nowrap cursor-pointer"
                role="button"
                onClick={() =>
                  onClick(item.machungkhoan, {
                    code: item.machungkhoan,
                    name: item.name,
                    label: item.label,
                  })
                }
              >
                <BarChartIcon className="hover:text-primary-main" />
              </span>
            </Styles.Icon>
          </Styles.Tooltip>

          <WrapperBookmark
            code={item.machungkhoan}
            isInvestmentCategoriesLoading={isInvestmentCategoriesLoading}
            authenticated={authenticated}
            investmentCategories={investmentCategories}
            followCompanies={followCompanies}
            saveInvestmentCategory={saveInvestmentCategory}
            deleteInvestmentCategory={deleteInvestmentCategory}
            investmentCategoriesMessage={investmentCategoriesMessage}
            isOpeningBookmark={isOpeningBookmark}
            handleSetIsOpeningBookmark={handleSetIsOpeningBookmark}
          />
        </span>
      ),
      [TOP_10_LOWEST_CODE]: (
        <div className="whitespace-nowrap flex items-center">
          <a
            href={`/${item.machungkhoan.toLowerCase()}-${removeVietnameseTones(
              item.name
            )}`}
            className="text-primary-main"
            title={`${item.name} | Mã chứng khoán: ${item.machungkhoan}`}
          >
            {item.machungkhoan}
          </a>
          <TopCompanyLabel label={item.label} />
        </div>
      ),
      [TOP_10_LOWEST_CLOSE_PRICE]: (
        <span className="whitespace-nowrap">
          {formatDisplayNumber(item.giadongcua, ',', 0)}
        </span>
      ),
      [TOP_10_LOWEST_CHANGE]: (
        <span
          className="whitespace-nowrap"
          style={{
            color: `${getStatusColor(
              item.giadongcua,
              item.giathamchieu,
              item.giatran,
              item.giasan
            )}`,
          }}
        >
          {formatDisplayNumber(item.thaydoi, ',', 0)} (
          {formatDisplayNumber(item.thaydoiphantram, ',', 0)}%)
        </span>
      ),
      [TOP_10_LOWEST_TRADING_VALUE]: (
        <span className="whitespace-nowrap">
          {formatDisplayNumber(
            formatTradingValue(Number(item.gtgd) / 1000),
            ',',
            0
          )}
        </span>
      ),
      [TOP_10_LOWEST_TRADING_VOLUME]: (
        <span className="whitespace-nowrap">
          {formatDisplayNumber(Number(item.klgd), ',', 0)}
        </span>
      ),
    };
  });
};

export const transferTop10TradingValueData = (
  data,
  isInvestmentCategoriesLoading,
  authenticated,
  investmentCategories,
  followCompanies,
  saveInvestmentCategory,
  deleteInvestmentCategory,
  investmentCategoriesMessage,
  isOpeningBookmark,
  handleSetIsOpeningBookmark,
  isDarkMode,
  position,
  onClick,
  handleTooltipOpen,
  top10ChartData
) => {
  return data.map((item) => {
    return {
      [TOP_10_TRADING_VALUE_ICON]: (
        <span className="column-icon flex justify-end">
          <Styles.Tooltip
            title={getTop10TooltipContent(
              top10ChartData,
              'klgd',
              item.machungkhoan,
              'KLGD',
              ' cp',
              isDarkMode,
              '',
              '150px',
              60,
              1000
            )}
            placement={position}
            onOpen={() => handleTooltipOpen(item.machungkhoan, 'gtgd')}
          >
            <Styles.Icon>
              <span
                className="whitespace-nowrap cursor-pointer"
                role="button"
                onClick={() =>
                  onClick(item.machungkhoan, {
                    code: item.machungkhoan,
                    name: item.name,
                    label: item.label,
                  })
                }
              >
                <BarChartIcon className="hover:text-primary-main" />
              </span>
            </Styles.Icon>
          </Styles.Tooltip>

          <WrapperBookmark
            code={item.machungkhoan}
            isInvestmentCategoriesLoading={isInvestmentCategoriesLoading}
            authenticated={authenticated}
            investmentCategories={investmentCategories}
            followCompanies={followCompanies}
            saveInvestmentCategory={saveInvestmentCategory}
            deleteInvestmentCategory={deleteInvestmentCategory}
            investmentCategoriesMessage={investmentCategoriesMessage}
            isOpeningBookmark={isOpeningBookmark}
            handleSetIsOpeningBookmark={handleSetIsOpeningBookmark}
          />
        </span>
      ),
      [TOP_10_TRADING_VALUE_CODE]: (
        <div className="whitespace-nowrap flex items-center">
          <a
            href={`/${item.machungkhoan.toLowerCase()}-${removeVietnameseTones(
              item.name
            )}`}
            className="text-primary-main"
            title={`${item.name} | Mã chứng khoán: ${item.machungkhoan}`}
          >
            {item.machungkhoan}
          </a>
          <TopCompanyLabel label={item.label} />
        </div>
      ),
      [TOP_10_TRADING_VALUE]: (
        <span className="whitespace-nowrap">
          {formatDisplayNumber(
            formatTradingValue(Number(item.gtgd) / 1000),
            ',',
            0
          )}
        </span>
      ),
      [TOP_10_TRADING_VALUE_CHANGE]: (
        <span
          className="whitespace-nowrap"
          style={{
            color: `${getStatusColor(
              item.giadongcua,
              item.giathamchieu,
              item.giatran,
              item.giasan
            )}`,
          }}
        >
          {formatDisplayNumber(item.thaydoi, ',', 0)} (
          {formatDisplayNumber(item.thaydoiphantram, ',', 0)}%)
        </span>
      ),
    };
  });
};

export const transferTop10TradingVolumeData = (
  data,
  isInvestmentCategoriesLoading,
  authenticated,
  investmentCategories,
  followCompanies,
  saveInvestmentCategory,
  deleteInvestmentCategory,
  investmentCategoriesMessage,
  isOpeningBookmark,
  handleSetIsOpeningBookmark,
  isDarkMode,
  position,
  onClick,
  handleTooltipOpen,
  top10ChartData
) => {
  return data.map((item) => {
    return {
      [TOP_10_TRADING_VOLUME_ICON]: (
        <span className="column-icon flex justify-end">
          <Styles.Tooltip
            title={getTop10TooltipContent(
              top10ChartData,
              'klgd',
              item.machungkhoan,
              'KLGD',
              ' cp',
              isDarkMode,
              '',
              '150px',
              60
            )}
            placement={position}
            onOpen={() => handleTooltipOpen(item.machungkhoan, 'klgd')}
          >
            <Styles.Icon>
              <span
                className="whitespace-nowrap cursor-pointer"
                role="button"
                onClick={() =>
                  onClick(item.machungkhoan, {
                    code: item.machungkhoan,
                    name: item.name,
                    label: item.label,
                  })
                }
              >
                <BarChartIcon className="hover:text-primary-main" />
              </span>
            </Styles.Icon>
          </Styles.Tooltip>

          <WrapperBookmark
            code={item.machungkhoan}
            isInvestmentCategoriesLoading={isInvestmentCategoriesLoading}
            authenticated={authenticated}
            investmentCategories={investmentCategories}
            followCompanies={followCompanies}
            saveInvestmentCategory={saveInvestmentCategory}
            deleteInvestmentCategory={deleteInvestmentCategory}
            investmentCategoriesMessage={investmentCategoriesMessage}
            isOpeningBookmark={isOpeningBookmark}
            handleSetIsOpeningBookmark={handleSetIsOpeningBookmark}
          />
        </span>
      ),
      [TOP_10_TRADING_VOLUME_CODE]: (
        <div className="whitespace-nowrap flex items-center">
          <a
            href={`/${item.machungkhoan.toLowerCase()}-${removeVietnameseTones(
              item.name
            )}`}
            className="text-primary-main"
            title={`${item.name} | Mã chứng khoán: ${item.machungkhoan}`}
          >
            {item.machungkhoan}
          </a>
          <TopCompanyLabel label={item.label} />
        </div>
      ),
      [TOP_10_TRADING_VOLUME]: (
        <span className="whitespace-nowrap">
          {formatDisplayNumber(Number(item.klgd), ',', 0)}
        </span>
      ),
      [TOP_10_TRADING_VOLUME_CHANGE]: (
        <span
          className="whitespace-nowrap"
          style={{
            color: `${getStatusColor(
              item.giadongcua,
              item.giathamchieu,
              item.giatran,
              item.giasan
            )}`,
          }}
        >
          {formatDisplayNumber(item.thaydoi, ',', 0)} (
          {formatDisplayNumber(item.thaydoiphantram, ',', 0)}%)
        </span>
      ),
    };
  });
};

export const getChart = (
  name,
  dark,
  xAxisData,
  series1Data,
  series2Data,
  series3Data,
  unit,
  interval,
  chartHeight = '150px',
  variant = '',
  left = 45,
  setSelectedChartPeriod = null,
  selectedChartPeriod = null,
  tradingValue = 'klgd',
  handleTradingChange = null
) => {
  const intervalRange = 5;
  const closePriceMinMax = getMinMax(series3Data);
  const minMaxAxisRight = generateMinMaxChartData(
    closePriceMinMax[0],
    closePriceMinMax[1],
    5,
    100
  );
  const otherMinMax = getMinMax([...series1Data, ...series2Data]);
  const minMaxAxisLeft = generateMinMaxChartData(0, otherMinMax[1], 5);
  const backgroundColor = dark && variant === 'modal' ? '#1a1c23' : '#fff';
  const color = dark && variant === 'modal' ? '#e5e7eb' : '#24262d';
  const option = {
    backgroundColor,
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999',
        },
        label: {
          formatter: function (params) {
            if (params.axisDimension === 'y') {
              if (params.axisIndex === 0) {
                return formatDisplayNumber(Math.floor(params.value));
              }

              return formatDisplayNumber(parseFloat(params.value.toFixed(2)));
            }
            return params.value;
          },
        },
      },
    },
    color: [
      HOME_CHART_COLOR.pink1,
      HOME_CHART_COLOR.pink2,
      HOME_CHART_COLOR.yellow,
    ],
    grid: {
      top: 35,
      bottom: 35,
      right: 35,
      left,
    },
    xAxis: {
      type: 'category',
      data: xAxisData,
      axisLabel: {
        color,
        interval,
        showMaxLabel: true,
        showMinLabel: true,
      },
      splitLine: {
        show: false,
      },
      axisLine: {
        show: true,
      },
    },
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          color,
          formatter: function (value) {
            if (value === 0) {
              return getAxisLabel(
                value,
                minMaxAxisLeft.min,
                minMaxAxisLeft.max
              );
            }

            return `${getAxisLabel(
              value,
              minMaxAxisLeft.min,
              minMaxAxisLeft.max
            )}${unit}`;
          },
        },
        splitLine: {
          show: false,
        },
        axisLine: {
          show: true,
        },
        min: minMaxAxisLeft.min,
        max: minMaxAxisLeft.max,
        interval: (minMaxAxisLeft.max - minMaxAxisLeft.min) / intervalRange,
      },
      {
        type: 'value',
        axisLabel: {
          color,
          formatter: function (value) {
            return `${getAxisLabel(
              value,
              minMaxAxisRight.min,
              minMaxAxisRight.max
            )}`;
          },
        },
        splitLine: {
          show: false,
        },
        axisLine: {
          show: true,
        },
        showSymbol: false,
        min: minMaxAxisRight.min,
        max: minMaxAxisRight.max,
        interval: (minMaxAxisRight.max - minMaxAxisRight.min) / intervalRange,
      },
    ],
    series: [
      {
        data: series1Data,
        type: 'bar',
        name: 'Khớp lệnh',
        tooltip: {
          valueFormatter: function (value) {
            return `${formatDisplayNumber(value, ',', 0)} ${unit}`;
          },
        },
        stack: 'total',
      },
      {
        data: series2Data,
        type: 'bar',
        name: 'Thoa thuận',
        stack: 'total',
        tooltip: {
          valueFormatter: function (value) {
            return `${formatDisplayNumber(value, ',', 0)} ${unit}`;
          },
        },
      },
      {
        data: series3Data,
        type: 'line',
        name: 'Giá đóng cửa',
        yAxisIndex: 1,
        showSymbol: false,
      },
    ],
  };

  if (variant === 'modal') {
    return (
      <Charts
        option={option}
        handlePeriodClick={setSelectedChartPeriod}
        selectedPeriod={selectedChartPeriod}
        tradingValue={tradingValue}
        handleTradingChange={handleTradingChange}
      />
    );
  }

  return (
    <Styles.ChartTooltipWrapper>
      <ECharts options={option} height={chartHeight} />
    </Styles.ChartTooltipWrapper>
  );
};

const ChartLoading = ({ minHeight = '150px' }) => {
  return (
    <Styles.LoadingWrapper style={{ minHeight }}>
      <Loading isLoading />
    </Styles.LoadingWrapper>
  );
};

const transferChartModalData = (items, field) => {
  const seriesPriceData = [];
  const seriesData1 = [];
  const seriesData2 = [];
  const xAxisData = [];
  for (let i = 0; i < items?.length; i++) {
    xAxisData.push(parseDate(items[i].DTYYYYMMDD));
    seriesPriceData.push(items[i].giadongcua);
    if (field === 'klgd') {
      seriesData1.push(Number(items[i].KLGDkhoplenh));
      seriesData2.push(Number(items[i].KLGDthoathuan));
    } else {
      seriesData1.push(Number(items[i].GTGDkhoplenh) / 1000);
      seriesData2.push(Number(items[i].GTGDthoathuan) / 1000);
    }
  }
  return {
    xAxisData,
    seriesPriceData,
    seriesData1,
    seriesData2,
  };
};

export const getTop10TooltipContent = (
  top10ChartData,
  chartField,
  code,
  title,
  unit,
  dark,
  variant = '',
  height = '150px',
  left = 50,
  setSelectedChartPeriod = null,
  selectedChartPeriod = null,
  handleTradingChange = null,
  isChartDataByCodeLoading = false
) => {
  if (!top10ChartData?.[code] || isChartDataByCodeLoading) {
    return <ChartLoading minHeight={variant === 'modal' ? '434px' : '150px'} />;
  }
  const {
    xAxisData,
    seriesPriceData,
    seriesData1,
    seriesData2,
  } = transferChartModalData(top10ChartData[code].data, chartField);

  return getChart(
    title,
    dark,
    xAxisData,
    seriesData1,
    seriesData2,
    seriesPriceData,
    unit,
    Math.floor(xAxisData.length / 2),
    height,
    variant,
    left,
    setSelectedChartPeriod,
    selectedChartPeriod,
    chartField,
    handleTradingChange
  );
};

export const transferTop5NegotiableTradingValueData = (
  isLoading,
  data,
  dark,
  position,
  onClick,
  handleTooltipOpen,
  top5ChartData,
  isInvestmentCategoriesLoading,
  authenticated,
  investmentCategories,
  followCompanies,
  saveInvestmentCategory,
  deleteInvestmentCategory,
  investmentCategoriesMessage,
  isOpeningBookmark,
  handleSetIsOpeningBookmark
) => {
  return data.map((item) => {
    return {
      [TOP_5_NEGOTIABLE_TRADING_VALUE]: (
        <div className="whitespace-nowrap flex items-center">
          <a
            href={`/${item.machungkhoan.toLowerCase()}-${removeVietnameseTones(
              item.name
            )}`}
            className="text-primary-main"
            title={`${item.name} | Mã chứng khoán: ${item.machungkhoan}`}
          >
            {item.machungkhoan}
          </a>
          <TopCompanyLabel label={item.label} />
        </div>
      ),
      [TOP_5_NEGOTIABLE_TRADING_VALUE_PUT_THROUGH]: (
        <span className="whitespace-nowrap">
          {formatDisplayNumber(
            formatTradingValue(Number(item.GTGDthoathuan) / 1000)
          )}{' '}
          tỷ
        </span>
      ),
      [TOP_5_NEGOTIABLE_TRADING_VALUE_CHANGE]: (
        <span
          className="whitespace-nowrap"
          style={{
            color: `${getStatusColor(
              item.giadongcua,
              item.giathamchieu,
              item.giatran,
              item.giasan
            )}`,
          }}
        >
          {formatDisplayNumber(item.thaydoi, ',', 0)} (
          {formatDisplayNumber(item.thaydoiphantram, ',', 0)}%)
        </span>
      ),
      [TOP_5_NEGOTIABLE_TRADING_VALUE_ICON]: (
        <span className="column-icon flex justify-end">
          <Styles.Tooltip
            title={getTop10TooltipContent(
              top5ChartData,
              'klgd',
              item.machungkhoan,
              'KLGD',
              ' cp',
              dark,
              '',
              '150px',
              60
            )}
            placement={position}
            onOpen={() => handleTooltipOpen(item.machungkhoan, 'gtgd')}
          >
            <Styles.Icon>
              <span
                className="whitespace-nowrap cursor-pointer"
                role="button"
                onClick={() =>
                  onClick(item.machungkhoan, {
                    code: item.machungkhoan,
                    name: item.name,
                    label: item.label,
                  })
                }
              >
                <BarChartIcon className="hover:text-primary-main" />
              </span>
            </Styles.Icon>
          </Styles.Tooltip>

          <WrapperBookmark
            code={item.machungkhoan}
            isInvestmentCategoriesLoading={isInvestmentCategoriesLoading}
            authenticated={authenticated}
            investmentCategories={investmentCategories}
            followCompanies={followCompanies}
            saveInvestmentCategory={saveInvestmentCategory}
            deleteInvestmentCategory={deleteInvestmentCategory}
            investmentCategoriesMessage={investmentCategoriesMessage}
            isOpeningBookmark={isOpeningBookmark}
            handleSetIsOpeningBookmark={handleSetIsOpeningBookmark}
          />
        </span>
      ),
    };
  });
};

export const transferTop5NegotiableTradingVolumeData = (
  data,
  dark,
  position,
  onClick,
  handleTooltipOpen,
  top5ChartData,
  isInvestmentCategoriesLoading,
  authenticated,
  investmentCategories,
  followCompanies,
  saveInvestmentCategory,
  deleteInvestmentCategory,
  investmentCategoriesMessage,
  isOpeningBookmark,
  handleSetIsOpeningBookmark
) => {
  return data.map((item) => {
    return {
      [TOP_5_NEGOTIABLE_TRADING_VOLUME]: (
        <div className="whitespace-nowrap flex items-center">
          <a
            href={`/${item.machungkhoan.toLowerCase()}-${removeVietnameseTones(
              item.name
            )}`}
            className="text-primary-main"
            title={`${item.name} | Mã chứng khoán: ${item.machungkhoan}`}
          >
            {item.machungkhoan}
          </a>
          <TopCompanyLabel label={item.label} />
        </div>
      ),
      [TOP_5_NEGOTIABLE_TRADING_VOLUME_PUT_THROUGH]: (
        <span className="whitespace-nowrap">
          {formatDisplayNumber(Number(item.KLGDthoathuan), ',', 0)} cp
        </span>
      ),
      [TOP_5_NEGOTIABLE_TRADING_VOLUME_CHANGE]: (
        <span
          className="whitespace-nowrap"
          style={{
            color: `${getStatusColor(
              item.giadongcua,
              item.giathamchieu,
              item.giatran,
              item.giasan
            )}`,
          }}
        >
          {formatDisplayNumber(item.thaydoi, ',', 0)} (
          {formatDisplayNumber(item.thaydoiphantram, ',', 0)}%)
        </span>
      ),
      [TOP_5_NEGOTIABLE_TRADING_VOLUME_ICON]: (
        <span className="column-icon flex justify-end">
          <Styles.Tooltip
            title={getTop10TooltipContent(
              top5ChartData,
              'klgd',
              item.machungkhoan,
              'KLGD',
              ' cp',
              dark,
              '',
              '150px',
              60
            )}
            placement={position}
            onOpen={() => handleTooltipOpen(item.machungkhoan, 'klgd')}
          >
            <span
              className="whitespace-nowrap cursor-pointer"
              role="button"
              onClick={() =>
                onClick(item.machungkhoan, {
                  code: item.machungkhoan,
                  name: item.name,
                  label: item.label,
                })
              }
            >
              <BarChartIcon className="hover:text-primary-main" />
            </span>
          </Styles.Tooltip>

          <WrapperBookmark
            code={item.machungkhoan}
            isInvestmentCategoriesLoading={isInvestmentCategoriesLoading}
            authenticated={authenticated}
            investmentCategories={investmentCategories}
            followCompanies={followCompanies}
            saveInvestmentCategory={saveInvestmentCategory}
            deleteInvestmentCategory={deleteInvestmentCategory}
            investmentCategoriesMessage={investmentCategoriesMessage}
            isOpeningBookmark={isOpeningBookmark}
            handleSetIsOpeningBookmark={handleSetIsOpeningBookmark}
          />
        </span>
      ),
    };
  });
};

export const getIndexFieldByStock = (selectedStock) => {
  switch (Number(selectedStock)) {
    case 2:
      return 'hnxIndex';
    case 3:
      return 'upcomIndex';
    default:
      return 'nvIndex';
  }
};

export const transferExchangeHistoryData = (
  exchangeHistory,
  auction,
  putThrough,
  chartField,
  selectedStock
) => {
  if (!exchangeHistory?.exchange?.length) {
    return null;
  }

  let dayAgo = exchangeHistory.dayAgo;
  let exchange = exchangeHistory.exchange;
  if (Number(selectedStock)) {
    dayAgo = exchangeHistory.dayAgo.filter(
      (e) => Number(e.stock_id) === Number(selectedStock)
    );
    exchange = exchangeHistory.exchange.filter(
      (e) => Number(e.stock_id) === Number(selectedStock)
    );
  }
  const totalDayAgo = dayAgo.reduce(
    (total, item) => total + Number(item[auction]) + Number(item[putThrough]),
    0
  );
  const totalCurrent = exchange.reduce(
    (total, item) => total + Number(item[auction]) + Number(item[putThrough]),
    0
  );
  const totalAuction = exchange.reduce(
    (total, item) => total + Number(item[auction]),
    0
  );
  const totalPutThrough = exchange.reduce(
    (total, item) => total + Number(item[putThrough]),
    0
  );
  const vnIndex = exchangeHistory.exchange.find(
    (item) => item.machungkhoan === 'VN-Index'
  );
  const hnxIndex = exchangeHistory.exchange.find(
    (item) => item.machungkhoan === 'HNX-Index'
  );
  const upcomIndex = exchangeHistory.exchange.find(
    (item) => item.machungkhoan === 'UPCOM-Index'
  );

  return {
    totalDayAgo,
    dateDayAgo: parseDate(exchangeHistory.dayAgo[0].DTYYYYMMDD),
    totalCurrent,
    totalAuction,
    totalPutThrough,
    vnIndex: Number(vnIndex[auction]) + Number(vnIndex[putThrough]),
    hnxIndex: Number(hnxIndex[auction]) + Number(hnxIndex[putThrough]),
    upcomIndex: Number(upcomIndex[auction]) + Number(upcomIndex[putThrough]),
  };
};
export const transferExchangeHistoryChartData = (
  exchangeHistory,
  chartField,
  selectedStock
) => {
  if (!exchangeHistory?.length) {
    return null;
  }
  const xAxisData = exchangeHistory.map((item) => parseDate(item.DTYYYYMMDD));
  const seriesData = exchangeHistory.map((item) => Number(item[chartField]));
  const series2Data = exchangeHistory.map((item) =>
    Number(item[getIndexFieldByStock(selectedStock)].giadongcua)
  );

  return {
    xAxisData,
    seriesData,
    series2Data,
  };
};

export const getDayAgoPercent = (current, dayAgo) => {
  const percent = ((current - dayAgo) * 100) / dayAgo;
  let color = 'text-gray-600 dark:text-gray-300';
  let icon = <SquareIcon className="day-ago-icon" />;
  if (dayAgo < current) {
    color = 'text-green-500';
    icon = <ArrowUpwardIcon className="day-ago-icon" />;
  } else if (dayAgo > current) {
    color = 'text-red-700 dark:text-red-500';
    icon = <ArrowDownwardIcon className="day-ago-icon" />;
  }
  return (
    <Styles.DayAgo>
      (
      <span className={color}>
        <span>
          {icon}
          <span className="inline-flex">
            {formatDisplayNumber(
              formatTradingValue(parseFloat(percent.toFixed(2))),
              ',',
              0
            )}
            %
          </span>
        </span>
      </span>
      )
    </Styles.DayAgo>
  );
};

const getTop5CompaniesForSectorChart = (
  companies,
  field,
  unit,
  total,
  range = 1
) => {
  let html = '';
  if (companies.length) {
    for (company of companies.slice(0, 5)) {
      const color = getStatusColor(
        company.giadongcua,
        company.giathamchieu,
        company.giatran,
        company.giasan
      );
      const value = Number(company[field]);
      html += `<div class="flex items-center mt-1">
            <span class="w-3.5 h-3.5 min-w-3.5 rounded-full inline-block mr-2" style="background: ${
              color === TC_COLORS.DEFAULT ? '#000' : color
            }"></span>
            <span class="mr-1">${company.machungkhoan}: </span>
            <span class="font-bold">${formatDisplayNumber(
              parseFloat((company[field] / range).toFixed(2))
            )} ${unit}(${((value * 100) / total)?.toFixed(2)}%)</span>
          </div>`;
    }
  }
  return html;
};

export const getSeriesDataForSectorChart = (
  newData,
  label,
  field,
  width,
  unit,
  range = 1,
  position = 'left'
) => {
  const seriesData = [];
  const sectorInfo = [];
  const total = newData.reduce((t, item) => t + item[field], 0);
  for (let i = 0; i < newData.length; i++) {
    const percent =
      newData[i][field] != 0
        ? ((Number(newData[i][field]) * 100) / total).toFixed(1)
        : 0;
    const companies = newData[i]?.companies;
    sectorInfo.push({
      index: i,
      id: newData[i].id,
      name: newData[i].name,
      color: CATEGORIES_COLOR[i],
    });
    seriesData.push({
      value: Number(newData[i][field]),
      name: `${percent}%`,
      itemStyle: {
        color: CATEGORIES_COLOR[i],
      },
      tooltip: {
        trigger: 'item',
        position: function () {
          if (width > 992) {
            return position;
          }
          return 'top';
        },
        formatter() {
          return `
            <div>
              <div class="flex items-center">
                <span class="font-bold">${
                  newData[i].name
                }: ${formatDisplayNumber(
            (newData[i][field] / range).toFixed(2)
          )} ${unit}(${percent}%)</span>
              </div>
              <div class="flex items-center">
                <span>----------------------------</span>
              </div>
              <div class="flex items-center">
                <span class="font-bold">${label}</span>
              </div>
              ${getTop5CompaniesForSectorChart(
                companies,
                field,
                unit,
                Number(newData[i][field]),
                range
              )}
            </div>
          `;
        },
      },
    });
  }

  return {
    seriesData,
    sectorInfo,
  };
};

export const transferHistoryCapChartData = (
  chartData,
  field,
  field2 = 'totalTradingVolumeCap',
  dayAgoField = '',
  exchangeHistoryChartData,
  selectedStock
) => {
  if (!chartData?.length && !exchangeHistoryChartData) {
    return null;
  }

  const xAxisData = [];
  const seriesData = [];
  const series2Data = [];
  const newData = [];
  const totalTradingCap = [];
  for (let i = 0; i < chartData.length; i++) {
    const date = parseDate(chartData[i].DTYYYYMMDD);
    if (i >= 1) {
      xAxisData.push(date);
      seriesData.push(Number(chartData[i][field]));
      totalTradingCap.push(chartData[i][field2]);
    }
    newData.push({
      total: Number(chartData[i][dayAgoField || field]),
      date,
    });
    if (exchangeHistoryChartData) {
      let findItem = exchangeHistoryChartData.find(
        (e) => e.DTYYYYMMDD === chartData[i].DTYYYYMMDD
      );
      if (findItem) {
        series2Data.push(
          Number(findItem[getIndexFieldByStock(selectedStock)].giadongcua)
        );
      } else {
        series2Data.push(series2Data[i - 1]);
      }
    }
  }

  const capMinMax = getMinMax(totalTradingCap);
  return {
    xAxisData,
    seriesData,
    newData,
    capMinMax,
    series2Data,
  };
};

export const getDayAgoPercentForChartTooltip = (current, dayAgo) => {
  const percent = ((current - dayAgo) * 100) / dayAgo;
  let color = 'text-gray-600 dark:text-gray-300';
  let icon = `<svg class="w-3.5 h-3.5 day-ago-icon" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="SquareIcon" style="fill: ${TC_COLORS.YELLOW}"><path d="M3 3h18v18H3z"></path></svg>`;
  if (dayAgo < current) {
    color = 'text-green-500';
    icon = `<svg class="w-3.5 h-3.5 day-ago-icon" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ArrowUpwardIcon"><path d="m4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z" style="fill: ${TC_COLORS.GREEN}"></path></svg>`;
  } else if (dayAgo > current) {
    color = 'text-red-700 dark:text-red-500';
    icon = `<svg class="w-3.5 h-3.5" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ArrowDownwardIcon" style="fill: ${TC_COLORS.RED}"><path d="m20 12-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"></path></svg>`;
  }
  return `
    <div class="inline-flex">
      (
        <span class="${color}">
          <span class="inline-flex items-center">
            ${icon}
            <span class="inline-flex">
              ${formatDisplayNumber(parseFloat(percent.toFixed(2)), ',', 0)}%
            </span>
          </span>
        </span>
      )
    </div>
  `;
};

export const formatCurrency = (value) => {
  return formatDisplayNumber(parseFloat((value / 1000).toFixed(2)));
};

export const getCapInterval = (xAxisData, width) => {
  if (width >= 1030) {
    return 65;
  }
  if ((width < 1030 && width >= 768) || (width < 530 && width >= 390)) {
    return Math.floor(xAxisData.length / 2);
  }

  if (width < 390) {
    return xAxisData.length;
  }

  return Math.floor(xAxisData.length / 3);
};

export const getSectorLegendColor = (sectorInfo, id) => {
  const item = sectorInfo.find((s) => s.id === id);
  return item;
};

export const getTop8TradingVolumeChart = (
  dark,
  data,
  chartHeight,
  variant,
  left,
  unit = ' cp',
  range = 1,
  field1 = 'KLGDkhoplenh',
  field2 = 'KLGDthoathuan'
) => {
  if (!data?.length) {
    return null;
  }
  const xAxisData = data.map((d) => parseDate(d.DTYYYYMMDD));
  const series1Data = data.map((d) => Number(d[field1]) / range);
  const series2Data = data.map((d) => Number(d[field2]) / range);
  const series3Data = data.map((d) => Number(d.giadongcua));
  const interval = Math.floor(xAxisData.length / 2);
  const intervalRange = 5;
  const closePriceMinMax = getMinMax(series3Data);
  const minMaxAxisRight = generateMinMaxChartData(
    closePriceMinMax[0],
    closePriceMinMax[1],
    5,
    100
  );
  const otherMinMax = getMinMax([...series1Data, ...series2Data]);
  const minMaxAxisLeft = generateMinMaxChartData(0, otherMinMax[1], 5);
  const backgroundColor = dark && variant === 'modal' ? '#1a1c23' : '#fff';
  const color = dark && variant === 'modal' ? '#e5e7eb' : '#24262d';
  const option = {
    backgroundColor,
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999',
        },
        label: {
          formatter: function (params) {
            if (params.axisDimension === 'y') {
              if (params.axisIndex === 0) {
                return formatDisplayNumber(Math.floor(params.value));
              }

              return formatDisplayNumber(parseFloat(params.value.toFixed(2)));
            }
            return params.value;
          },
        },
      },
    },
    color: [
      HOME_CHART_COLOR.pink1,
      HOME_CHART_COLOR.pink2,
      HOME_CHART_COLOR.yellow,
    ],
    grid: {
      top: 35,
      bottom: 35,
      right: 35,
      left,
    },
    xAxis: {
      type: 'category',
      data: xAxisData,
      axisLabel: {
        color,
        interval,
        showMaxLabel: true,
        showMinLabel: true,
      },
      splitLine: {
        show: false,
      },
      axisLine: {
        show: true,
      },
    },
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          color,
          formatter: function (value) {
            if (value === 0) {
              return getAxisLabel(
                value,
                minMaxAxisLeft.min,
                minMaxAxisLeft.max
              );
            }
            return `${getAxisLabel(
              value,
              minMaxAxisLeft.min,
              minMaxAxisLeft.max
            )} ${unit}`;
          },
        },
        splitLine: {
          show: false,
        },
        axisLine: {
          show: true,
        },
        min: minMaxAxisLeft.min,
        max: minMaxAxisLeft.max,
        interval: (minMaxAxisLeft.max - minMaxAxisLeft.min) / intervalRange,
      },
      {
        type: 'value',
        axisLabel: {
          color,
          formatter: function (value) {
            if (value === 0) {
              return getAxisLabel(
                value,
                minMaxAxisRight.min,
                minMaxAxisRight.max
              );
            }

            return `${getAxisLabel(
              value,
              minMaxAxisRight.min,
              minMaxAxisRight.max
            )}`;
          },
        },
        splitLine: {
          show: false,
        },
        axisLine: {
          show: true,
        },
        showSymbol: false,
        min: minMaxAxisRight.min,
        max: minMaxAxisRight.max,
        interval: (minMaxAxisRight.max - minMaxAxisRight.min) / intervalRange,
      },
    ],
    series: [
      {
        data: series1Data,
        type: 'bar',
        name: 'Khớp lệnh',
        stack: 'total',
        tooltip: {
          valueFormatter: function (value) {
            return `${formatDisplayNumber(value, ',', 0)} ${unit}`;
          },
        },
      },
      {
        data: series2Data,
        type: 'bar',
        name: 'Thỏa thuận',
        stack: 'total',
        tooltip: {
          valueFormatter: function (value) {
            return `${formatDisplayNumber(value, ',', 0)} ${unit}`;
          },
        },
      },
      {
        data: series3Data,
        type: 'line',
        name: 'Giá đóng cửa',
        yAxisIndex: 1,
        showSymbol: false,
      },
    ],
  };
  if (variant === 'modal') {
    return <ECharts options={option} height={chartHeight} />;
  }

  return (
    <Styles.ChartTooltipWrapper>
      <ECharts options={option} height={chartHeight} />
    </Styles.ChartTooltipWrapper>
  );
};

export const transferTop8TradingVolumeBySectorData = (
  data,
  total,
  dark,
  position,
  onChartIconClick,
  handleTooltipOpen,
  top8ChartData,
  isInvestmentCategoriesLoading,
  authenticated,
  investmentCategories,
  followCompanies,
  saveInvestmentCategory,
  deleteInvestmentCategory,
  investmentCategoriesMessage,
  isOpeningBookmark,
  handleSetIsOpeningBookmark
) => {
  return data.map((item) => {
    const color = getStatusColor(
      item.giadongcua,
      item.giathamchieu,
      item.giatran,
      item.giasan
    );
    return {
      [TOP_8_VOLUME_SECTOR_ICON]: (
        <span className="column-icon flex justify-end items-center">
          <Styles.Tooltip title={getTooltipTitle(item)} className="info">
            <span
              className="w-3.5 h-3.5 min-w-3.5 rounded-full inline-block mr-2"
              style={{
                backgroundColor: `${getStatusColor(
                  item.giadongcua,
                  item.giathamchieu,
                  item.giatran,
                  item.giasan
                )}`,
              }}
            />
          </Styles.Tooltip>
          <Styles.Tooltip
            title={getTop10TooltipContent(
              top8ChartData,
              'klgd',
              item.machungkhoan,
              'KLGD',
              ' cp',
              dark,
              '',
              '150px',
              60
            )}
            placement={position}
            onOpen={() => handleTooltipOpen(item.machungkhoan, 'klgd')}
          >
            <span
              className="whitespace-nowrap cursor-pointer"
              role="button"
              onClick={() =>
                onChartIconClick(item.machungkhoan, {
                  code: item.machungkhoan,
                  name: item.name,
                  label: item.label,
                })
              }
            >
              <BarChartIcon className="hover:text-primary-main" />
            </span>
          </Styles.Tooltip>
          <WrapperBookmark
            code={item.machungkhoan}
            isInvestmentCategoriesLoading={isInvestmentCategoriesLoading}
            authenticated={authenticated}
            investmentCategories={investmentCategories}
            followCompanies={followCompanies}
            saveInvestmentCategory={saveInvestmentCategory}
            deleteInvestmentCategory={deleteInvestmentCategory}
            investmentCategoriesMessage={investmentCategoriesMessage}
            isOpeningBookmark={isOpeningBookmark}
            handleSetIsOpeningBookmark={handleSetIsOpeningBookmark}
          />
        </span>
      ),
      [TOP_8_VOLUME_SECTOR]: (
        <div className="whitespace-nowrap flex items-center">
          <a
            href={`/${item.machungkhoan.toLowerCase()}-${removeVietnameseTones(
              item.name
            )}`}
            className="text-primary-main"
            title={`${item.name} | Mã chứng khoán: ${item.machungkhoan}`}
          >
            {item.machungkhoan}
          </a>
          <TopCompanyLabel label={item.label} />
        </div>
      ),
      [TOP_8_VOLUME_SECTOR_TRADING_VOLUME]: (
        <span className="whitespace-nowrap">
          {formatDisplayNumber(Number(item.klgd))} cp (
          {((Number(item.klgd) * 100) / total)?.toFixed(2)}%)
        </span>
      ),
    };
  });
};

export const transferTop8TradingValueBySectorData = (
  data,
  total,
  dark,
  position,
  onChartIconClick,
  handleTooltipOpen,
  top8ChartData,
  isInvestmentCategoriesLoading,
  authenticated,
  investmentCategories,
  followCompanies,
  saveInvestmentCategory,
  deleteInvestmentCategory,
  investmentCategoriesMessage,
  isOpeningBookmark,
  handleSetIsOpeningBookmark
) => {
  return data.map((item) => {
    const color = getStatusColor(
      item.giadongcua,
      item.giathamchieu,
      item.giatran,
      item.giasan
    );
    return {
      [TOP_8_VALUE_SECTOR_ICON]: (
        <span className="column-icon flex justify-end items-center">
          <Styles.Tooltip title={getTooltipTitle(item)} className="info">
            <span
              className="w-3.5 h-3.5 min-w-3.5 rounded-full inline-block mr-2"
              style={{
                backgroundColor: `${getStatusColor(
                  item.giadongcua,
                  item.giathamchieu,
                  item.giatran,
                  item.giasan
                )}`,
              }}
            />
          </Styles.Tooltip>
          <Styles.Tooltip
            title={getTop10TooltipContent(
              top8ChartData,
              'klgd',
              item.machungkhoan,
              'KLGD',
              ' cp',
              dark,
              '',
              '150px',
              60
            )}
            placement={position}
            onOpen={() => handleTooltipOpen(item.machungkhoan, 'gtgd')}
          >
            <span
              className="whitespace-nowrap cursor-pointer"
              role="button"
              onClick={() =>
                onChartIconClick(item.machungkhoan, {
                  code: item.machungkhoan,
                  name: item.name,
                  label: item.label,
                })
              }
            >
              <BarChartIcon className="hover:text-primary-main" />
            </span>
          </Styles.Tooltip>

          <WrapperBookmark
            code={item.machungkhoan}
            isInvestmentCategoriesLoading={isInvestmentCategoriesLoading}
            authenticated={authenticated}
            investmentCategories={investmentCategories}
            followCompanies={followCompanies}
            saveInvestmentCategory={saveInvestmentCategory}
            deleteInvestmentCategory={deleteInvestmentCategory}
            investmentCategoriesMessage={investmentCategoriesMessage}
            isOpeningBookmark={isOpeningBookmark}
            handleSetIsOpeningBookmark={handleSetIsOpeningBookmark}
          />
        </span>
      ),
      [TOP_8_VALUE_SECTOR]: (
        <div className="whitespace-nowrap flex items-center">
          <a
            href={`/${item.machungkhoan.toLowerCase()}-${removeVietnameseTones(
              item.name
            )}`}
            className="text-primary-main"
            title={`${item.name} | Mã chứng khoán: ${item.machungkhoan}`}
          >
            {item.machungkhoan}
          </a>
          <TopCompanyLabel label={item.label} />
        </div>
      ),
      [TOP_8_VALUE_SECTOR_TRADING_VOLUME]: (
        <span className="whitespace-nowrap">
          {formatDisplayNumber(
            parseFloat((Number(item.gtgd) / 1000).toFixed(2))
          )}{' '}
          tỷ ({((Number(item.gtgd) * 100) / total)?.toFixed(2)}%)
        </span>
      ),
    };
  });
};

export const getIndexNameByStock = (selectedStock) => {
  switch (Number(selectedStock)) {
    case 2:
      return 'HNX-Index';
    case 3:
      return 'UPCOM-Index';
    default:
      return 'VN-Index';
  }
};

export const getIndexStatusColor = (value) => {
  let color = TC_COLORS.YELLOW;
  let icon =
    '<svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="SquareIcon"><path d="M3 3h18v18H3z"></path></svg>';
  if (value > 0) {
    color = TC_COLORS.GREEN;
    icon =
      '<svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ArrowUpwardIcon"><path d="m4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"></path></svg>';
  } else if (value < 0) {
    color = TC_COLORS.RED;
    icon =
      '<svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ArrowDownwardIcon"><path d="m20 12-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"></path></svg>';
  }

  return {
    color,
    icon,
  };
};

export const getIndexTooltipForTradingChart = (item, selectedStock) => {
  return `
    <span class="flex items-center" style="color: ${
      getIndexStatusColor(item[getIndexFieldByStock(selectedStock)].thaydoi)
        .color
    }">
      <span>${
        getIndexStatusColor(item[getIndexFieldByStock(selectedStock)].thaydoi)
          .icon
      }</span>
      <span class="ml-2 text-left inline-flex items-center">
        <span class="inline-block text-sm">${formatDisplayNumber(
          item[getIndexFieldByStock(selectedStock)].giadongcua
        )}</span>
        <span class="inline-block text-xs ml-2">
          ${formatDisplayNumber(
            item[getIndexFieldByStock(selectedStock)].thaydoi
          )} (${formatDisplayNumber(
    item[getIndexFieldByStock(selectedStock)].thaydoiphantram
  )}%)
        </span>
      </span>
    </span>
  `;
};

const getTooltipTitle = (item) => {
  return (
    <div className="text-gray-600 dark:text-gray-200 text-sm p-2">
      <div>{parseDate(item.current.DTYYYYMMDD)}</div>
      <div className="grid grid-cols-2 gap-x-5 gap-y-2 mt-2">
        <div className="whitespace-nowrap flex justify-between">
          <span>Giá mở của:</span>
          <span className="font-bold inline-block ml-1">
            {item.current.giamocua}
          </span>
        </div>
        <div className="whitespace-nowrap flex justify-between">
          <span>Giá cao nhất:</span>
          <span className="font-bold inline-block ml-1">
            {item.current.giacaonhat}
          </span>
        </div>
        <div className="whitespace-nowrap flex justify-between">
          <span>Giá đóng của:</span>
          <span className="font-bold inline-block ml-1">{item.giadongcua}</span>
        </div>
        <div className="whitespace-nowrap flex justify-between">
          <span>Giá thấp nhất:</span>
          <span className="font-bold inline-block ml-1">
            {item.current.giathapnhat}
          </span>
        </div>
        <div className="whitespace-nowrap flex justify-between">
          <span>KLGD:</span>
          <span className="font-bold inline-block ml-1">
            {formatDisplayNumber(item.current.KLGD)} cp
          </span>
        </div>
        <div className="whitespace-nowrap flex justify-between">
          <span>KL mua:</span>
          <span className="font-bold inline-block ml-1">
            {formatDisplayNumber(item.current.tonggiaodichmua)} cp
          </span>
        </div>
        <div className="whitespace-nowrap flex justify-between">
          <span>GTGD:</span>
          <span className="font-bold inline-block ml-1">
            {formatDisplayNumber(
              formatTradingValue(Number(item.current.GTGD) / 1000),
              ',',
              0
            )}{' '}
            tỷ
          </span>
        </div>
        <div className="whitespace-nowrap flex justify-between">
          <span>KL bán:</span>
          <span className="font-bold inline-block ml-1">
            {formatDisplayNumber(item.current.tonggiaodichban)} cp
          </span>
        </div>
        <div className="whitespace-nowrap flex justify-between">
          <span>Thay đổi:</span>
          <span className="font-bold inline-block ml-1">
            {formatDisplayNumber(item.current.thaydoi)}(
            {formatDisplayNumber(item.current.thaydoiphantram)}%)
          </span>
        </div>
      </div>
    </div>
  );
};

export const transferTop10GoDownByStockUpeData = (
  data,
  field,
  handleOpenTop10GoUpGoDownTooltip,
  isDarkMode,
  top10GoUpGoDownChartData,
  onChartIconClick,
  isInvestmentCategoriesLoading,
  authenticated,
  investmentCategories,
  followCompanies,
  saveInvestmentCategory,
  deleteInvestmentCategory,
  investmentCategoriesMessage,
  isOpeningBookmark,
  handleSetIsOpeningBookmark
) => {
  if (!data?.length) {
    return null;
  }

  return data.map((item) => {
    return {
      [TOP_10_GO_UP_GO_DOWN_CODE]: (
        <div className="whitespace-nowrap flex items-center">
          <Styles.Tooltip title={getTooltipTitle(item)} className="info">
            <span
              className="w-3.5 h-3.5 min-w-3.5 rounded-full inline-block mr-2"
              style={{
                backgroundColor: `${getStatusColor(
                  item.giadongcua,
                  item.giathamchieu,
                  item.giatran,
                  item.giasan
                )}`,
              }}
            />
          </Styles.Tooltip>
          <a
            href={`/${item.machungkhoan.toLowerCase()}-${removeVietnameseTones(
              item.name
            )}`}
            className="text-primary-main"
            title={`${item.name} | Mã chứng khoán: ${item.machungkhoan}`}
          >
            {item.machungkhoan}
          </a>
          <TopCompanyLabel label={item.label} />
        </div>
      ),
      [TOP_10_GO_UP_GO_DOWN_TRADING_VOLUME]: (
        <span className="whitespace-nowrap">
          {formatDisplayNumber(formatTradingValue(Number(item.KLGD), 0))} cp
        </span>
      ),
      [TOP_10_GO_UP_GO_DOWN_TRADING_VALUE]: (
        <span className="whitespace-nowrap">
          {formatDisplayNumber(formatTradingValue(Number(item.GTGD) / 1000, 2))}{' '}
          tỷ
        </span>
      ),
      [TOP_10_GO_UP_GO_DOWN_CHANGE]: (
        <span
          className="whitespace-nowrap"
          style={{ color: item.value < 0 ? TC_COLORS.RED : TC_COLORS.GREEN }}
        >
          {item.value < 0 ? (
            <ArrowDownwardIcon className="day-ago-icon" />
          ) : (
            <ArrowUpwardIcon className="day-ago-icon" />
          )}
          {formatDisplayNumber(item.value, ',', 0)} (
          {item.percent
            ? formatDisplayNumber(parseFloat(item.percent.toFixed(2)), ',', 0)
            : 0}
          %)
        </span>
      ),
      [TOP_10_GO_UP_GO_DOWN_ICON]: (
        <span className="column-icon flex justify-end">
          <Styles.Tooltip
            title={getTop10TooltipContent(
              top10GoUpGoDownChartData,
              'klgd',
              item.machungkhoan,
              'KLGD',
              ' cp',
              isDarkMode,
              '',
              '150px',
              60
            )}
            onOpen={() =>
              handleOpenTop10GoUpGoDownTooltip(item.machungkhoan, field)
            }
          >
            <span
              className="whitespace-nowrap cursor-pointer"
              role="button"
              onClick={() =>
                onChartIconClick(item.machungkhoan, {
                  code: item.machungkhoan,
                  name: item.name,
                  label: item.label,
                })
              }
            >
              <BarChartIcon />
            </span>
          </Styles.Tooltip>
          <WrapperBookmark
            code={item.machungkhoan}
            isInvestmentCategoriesLoading={isInvestmentCategoriesLoading}
            authenticated={authenticated}
            investmentCategories={investmentCategories}
            followCompanies={followCompanies}
            saveInvestmentCategory={saveInvestmentCategory}
            deleteInvestmentCategory={deleteInvestmentCategory}
            investmentCategoriesMessage={investmentCategoriesMessage}
            isOpeningBookmark={isOpeningBookmark}
            handleSetIsOpeningBookmark={handleSetIsOpeningBookmark}
          />
        </span>
      ),
    };
  });
};

export const tradingPeriod = [
  {
    value: 6,
    label: '6T',
  },
  {
    value: 12,
    label: '12T',
  },
  {
    value: 24,
    label: '24T',
  },
  {
    value: 36,
    label: '36T',
  },
  {
    value: 0,
    label: 'Tất cả',
  },
];

const getTooltipContent = (type, value, label = '') => {
  const prefix = type === 'value' ? 'Giá trị' : 'Khối lượng';
  if (value !== 0) {
    if (label) {
      return `${prefix} giao dịch trong ${label}`;
    }
    return `${prefix} giao dịch trong ${value} tháng`;
  }
  return `Xem chi tiêt thống kê ${prefix.toLowerCase()} giao dịch`;
};

export const getPeriod = (
  type,
  onClick,
  selectedPeriod,
  periods = tradingPeriod
) => {
  const handlePeriodClick = (_type, _value) => {
    const userId = document.getElementById('userId')?.value;
    if (!userId && ![6, 12].includes(_value)) {
      document.location.href = '/login';
    } else {
      onClick(_type, _value);
    }
  };
  return (
    <ul className="flex justify-end w-full my-3">
      {periods?.map((p) => (
        <li key={p.value} className="ml-1 ssm:ml-2">
          <Tooltip title={getTooltipContent(type, p.value, p?.alias)}>
            <span>
              <Button
                variant={selectedPeriod === p.value ? 'contained' : 'outlined'}
                onClick={() => handlePeriodClick(type, p.value)}
                className="small btn-period whitespace-nowrap"
              >
                {p.label}
              </Button>
            </span>
          </Tooltip>
        </li>
      ))}
    </ul>
  );
};
